
/**
 * Header collapsible menu on mobile
 */
try {
  (function () {
    const acc = document.getElementsByClassName('header-drawer-v2__accordion-group');
    const handleActiveCollapseAccordion = (index = 0) => {
      const currentEl = acc[index];
      const currentActived = currentEl.classList.contains('active');
      const panel = currentEl.querySelector('.header-drawer-v2__accordion-extension');
      if (!panel) return;
      if (currentActived) {
        currentEl.classList.remove('active');
        panel.style.maxHeight = 0;
      } else {
        // collapseAll
        for (let j = 0; j < acc.length; j++) {
          acc[j].classList.remove('active');
          const extension = acc[j].querySelector('.header-drawer-v2__accordion-extension')
          if (extension) extension.style.maxHeight = 0;
        }
        // active
        currentEl.classList.add('active');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    };

    window.addEventListener('resize', function () {
      // update height
      for (let j = 0; j < acc.length; j++) {
        const panel = acc[j].querySelector('.header-drawer-v2__accordion-extension');
        const oldHeight = panel.scrollHeight + 'px';
        if (!panel) return;
        if (!acc[j].classList.contains('active')) return;
        if (panel.style.maxHeight != '0px' && panel.style.maxHeight != oldHeight) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      }
    });

    // accordion click event
    for (let i = 0; i < acc.length; i++) {
      const tirgger = acc[i].querySelector(".header-drawer-v2__accordion-trigger");
      if (tirgger) tirgger.addEventListener('click', function () {
        handleActiveCollapseAccordion(i);
      });
    }
  })();
} catch (error) {
  console.error(error)
}
(function () {
  const toggleButton = document.querySelector("[data-drawer-toggle='hamburger']");
  const overlay = document.querySelector(".header-drawer-v2__overlay");
  const drawer = document.querySelector("#header-drawer-v2");
  const header = document.querySelector("[data-header-wrapper]");
  function toggleDrawer() {
    const isClosed = drawer.getAttribute("aria-hidden") == "true";
    drawer.setAttribute("aria-hidden", isClosed ? "false" : "true");
    toggleButton.setAttribute("aria-expanded", isClosed ? "true" : "false");
    const header = document.querySelector("[data-header-wrapper]");
    const announcement = document.querySelector("[data-announcement-wrapper]");
    // 使用主题自带功能在 IOS 下 drawer 内会无法滑动
    // isClosed ?
    //   document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true })) :
    //   document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    isClosed ?
      document.querySelector("body").style.overflow = "hidden" :
      document.querySelector("body").style.overflow = "initial";
    const supportTransparent = header.getAttribute("data-header-transparent-support") == "true";
    if (supportTransparent) {
      if (isClosed) {
        header.setAttribute("data-header-transparent", "false");
      } else {
        header.setAttribute("data-header-transparent", window.scrollY > announcement.clientHeight ? "false" : "true");
      }
    }
  }
  if (toggleButton) {
    toggleButton.addEventListener("click", () => toggleDrawer());
  }
  if (overlay) {
    overlay.addEventListener("click", () => toggleDrawer());
  }
})();